<template>
  <v-container id="terms-and-conditions">
    <v-row>
      <v-col class="display-2">
        {{ this.$t("title.terms_and_conditions") }}
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col
        style="min-height: 500px"
        v-html="$store.state.config.template_settings.terms_and_conditions"
      ></v-col>
    </v-row> </v-container
></template>

<script>
export default {
  name: "TermsAndConditionsPage"
};
</script>

<style scoped></style>
